import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Reserves the same vertical space as version-pager while the version history is loading,
 * so the form content does not shift when the pager appears.
 */
@Component({
  selector: 'fb-version-pager-skeleton',
  templateUrl: './version-pager-skeleton.component.html',
  styleUrl: './version-pager-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionPagerSkeletonComponent {}
